import {doAjax} from "surveylabJsAssets/common/_ajax";

interface DbSelectRequest {
    parentSelectValue: string,
    dbPluginName: string
}

interface DbSelectResponse {
    options: object
}

export default abstract class AbstractDbSelect {
    protected selectContainerClass: string;
    protected validOptionsSelector: string;

    public init(): void {
        // loop through all selects who has a parent select
        $('select[data-parent-id]').each((i, target) => {
            const $select = $(target);
            const $parentSelect = $(`select#${$select.data('parentId')}`);
            if ($parentSelect.length) {
                if (!this.getOptionsWithValue($parentSelect).length) {
                    this.getOptionsWithValue($select).remove();
                }
                if ($parentSelect.val() && !$select.val()) {
                    // on init: if the parent has already a value (eg. non '- please select -') and the select has not already a value, poplulate the select
                    this.populateSelect($select, $parentSelect);
                }
                $parentSelect.on('change', () => {
                    this.populateSelect($select, $parentSelect);
                });
            }
            this.toggleSelectContainer($select);
        });
    }

    protected populateSelect($select: JQuery, $parentSelect: JQuery): void {
        doAjax({
            url: $select.data('ajaxUrl'),
            data: <DbSelectRequest>{
                parentSelectValue: $parentSelect.val(),
                dbPluginName: $select.data('dbPluginName')
            }
        }).done((response: DbSelectResponse) => {
            let options = '';
            for (const [key, value] of Object.entries(response.options)) {
                options += `<option value="${key}">${value}</option>`;
            }
            // remove all the select option beside the empy value one and then append the new valid option
            this.getOptionsWithValue($select).remove();
            $select.append(options);
            $select.trigger('change');
            this.toggleSelectContainer($select);
        });
    }

    protected toggleSelectContainer($select: JQuery): void {
        const $selectContainer = $select.parents(`.${this.selectContainerClass}`);
        // show if the select has some vaslid option or if it's force required
        this.getOptionsWithValue($select).length || $select.data('isRequired') ? $selectContainer.show() : $selectContainer.hide();
    }

    protected getOptionsWithValue($select: JQuery): JQuery {
        return $(this.validOptionsSelector, $select);
    }
}
